module.exports = __webpack_public_path__ + "img/special_creamf_202403.05725128.jpg";